import React from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'react-responsive-modal';
import IconComponent from 'style/fonts/glyphmaps/icon.component';
import { removeArticleComment } from 'store/action/articles.action';
import { toast } from 'react-toastify';

export default function CommentOptionModal({ open, close, id }) {
  const dispatch = useDispatch();

  const _removeComment = () => {
    dispatch(removeArticleComment(id))
      .then(data => {
        toast.success('Comentário excluído com sucesso!');
      })
      .catch(error =>
        toast.error('Ocorreu um erro ao excluir comentário. Tente novamente!')
      );
    close();
  };

  return (
    <Modal open={open} onClose={close} center className="w-50">
      <div
        className="flex-column justify-center"
        style={{
          width: '200px',
          height: '50px',
          marginRight: '20px',
          marginTop: '30px',
        }}
      >
        <div className="flex-row justify-between align-center">
          <span>Excluir comentário</span>
          <IconComponent
            fontFamily="FontAwesome"
            name="trash"
            className="article-icon"
            color="gray"
            size={22}
            onClick={_removeComment}
          />
        </div>
      </div>
    </Modal>
  );
}
